import React, {useEffect, useState} from 'react';
import {withStyles} from '@material-ui/core/styles'
import {connect} from "react-redux";
import {deepCmp} from "../../../../../helpers/JsUtils";
import MapView from "../item-map/MapView";


const styles = {
};

function ItemsMap(props) {
  const { mapOpen, mindfileId, isDialogOpen, openItemViewDialog, getMindfileItemLocations, setMapBounds, controller, filters, filterSelections, itemLocations, itemMap, selectedIds } = props;

  const [mounted, setMounted] = useState(false);
  const [visibleItemIds, setVisibleItemIds] = useState(null);
  const [markers, setMarkers] = useState([]);
  const [curMapBounds, setCurMapBounds] = useState(null);


  useEffect(() => {
      if (mounted && mapOpen && !isDialogOpen) {
        setMapBounds(curMapBounds);
      }
    },
    // eslint-disable-next-line
    [visibleItemIds]
  );

  useEffect(() => {
      let fetchFilters =  Object.fromEntries(filters.map((f,index) => f.enabled && !!filterSelections[index].selectedItems && filterSelections[index].selectedItems.length > 0 ? [f.key, filterSelections[index].selectedItems] : null).filter(item => !!item));
      // let fetchFilters =  Object.fromEntries(filters.map((f,index) => f.enabled ? [f.key, filterSelections[index].selectedItems] : null).filter(item => !!item));
      getMindfileItemLocations(mindfileId, controller, fetchFilters, () => {
        setMounted(true);
      }, () => {}, () => {})
    },
    // eslint-disable-next-line
    [controller.search, filterSelections]
  );

  useEffect(() => {
      if(!mounted || !curMapBounds || !itemLocations){
        return;
      }
      const west_lng = curMapBounds.nw.lng;
      const east_lng = curMapBounds.se.lng;
      const visibleIds = [];
      const visibleMarkers = [];
      const hiddenMarkers = [];
      (itemLocations||[]).forEach((item) => {
        let lng = item.longitude;
        if(lng < west_lng){
          lng += (Math.floor((west_lng - lng)/360) + 1) * 360;
        }else if(lng > east_lng){
          lng -= (Math.floor((lng - east_lng)/360) + 1) * 360;
        }
        const lat = item.latitude;
        const marker = {pointId: parseInt(item.id), lat: lat, lng: lng}
        if(lat >= curMapBounds.se.lat && lat <= curMapBounds.nw.lat &&
            lng >= west_lng && lng <= east_lng) {
          visibleIds.push(item.id);
          visibleMarkers.push(marker);
        }else{
          hiddenMarkers.push(marker);
        }
      });
      setMarkers([visibleMarkers, hiddenMarkers]);
      const sortedIds = visibleIds.sort();
      if(!deepCmp(sortedIds, visibleItemIds)){
        setVisibleItemIds(visibleIds);
      }
    },
    // eslint-disable-next-line
    [itemLocations, curMapBounds, mounted]
  )

  return (
    <div style={{ height: "calc(max(40vh, min(400px, 90vh))", width: "100%", position: "relative" }}>
      <MapView
        itemMap={itemMap}
        selectedIds={selectedIds}
        mapBounds={curMapBounds}
        setMapBounds={setCurMapBounds}
        markers={markers[0]}
        markersHidden={markers[1]}
        openFileDialog={!openItemViewDialog ? null : itemId => openItemViewDialog(itemId, null)}
      />
    </div>
  );
}

const mapStateToProps = state => {
  return {
    mindfile:state.mindfile,
    itemLocations:state.itemLocations.locations
  };
}

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ItemsMap));
